import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

// services
import { OrdersService } from '../services/orders.service';

// interface
import { OrderDetails } from '../interfaces/order-details'

@Component({
    selector: 'app-order-delete',
    templateUrl: './order-delete.component.html',
    styleUrls: ['./order-delete.component.scss']
})
export class OrderDeleteComponent implements OnInit {

	@BlockUI() blockUI: NgBlockUI;

    @Input() public order: OrderDetails;
    @Input() public network;
    @Output() updateData: EventEmitter<{status: string, message:string}> = new EventEmitter();

    constructor(
    public activeModal: NgbActiveModal,
    private ordersService: OrdersService,
    ) { }

    ngOnInit(): void { }

    deleteOrder(): void {
        this.blockUI.start();

        this.ordersService.deleteOrder(this.order.id, this.network).subscribe(
            (res) => {
                if (res.success) {
                    this.blockUI.stop();
                    this.updateData.emit({status: 'success', message: `La commande n°${this.order.parentId} a bien été supprimé`});
                    this.activeModal.close();

                } else {
                    this.blockUI.stop();
                    this.updateData.emit({status: 'error', message: `La commande n°${this.order.parentId} n'a pas été supprimé, paramètre invalide`});
                    this.activeModal.close();
                }
            },
            (error) => {
                this.blockUI.stop();
                this.updateData.emit({status: 'error', message: `La commande n°${this.order.parentId} n'a pas été supprimé, une erreur serveur s'est produite`});
                this.activeModal.close();
            }
        );
    }
}
